export class initSwiper {
    constructor() {
        var Swiper = require('swiper').default;

        (window as any).initSwiper = function (swiperId: string, swiperParams: object) {

            const swiperItem = document.getElementById(swiperId)
             
            var mySwiper = new Swiper(swiperItem, swiperParams) 
        }
    }
}

var swiper = new initSwiper();
export default swiper;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/init-swiper.ts